<template>
  <v-container>
    <template>
   <CRUDList
      ref="crudList"
      :canAdd="canAddToSharedList"
      :canEdit="true"
      :canSave="canEditSharedList"
      :showSelect="false"
      :enableFixedHeaders="true"
      :displayTopPagination="false"
      :canDeleteInDialog="true"
      :headers="headers"
      :selectedItems="selectedItems"
      :baseCrudKey="baseCrudKey"
      :dialogHeaderName="dialogHeaderName"
      :defaultSortBy="defaultSortBy"
      :tableTitle="dialogHeaderName"
      dialogDynamicWidth="60vw"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='450'
      @upsertItem="upsertRecords"
      @deleteItem="deleteFromDiaglog"
      @emitSelectedItem="emitSelectedItem"
      @loadCRUDList="handleMtgCodesLoad"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
    >
    <template v-slot:[`additionalActionsTop`]>
      <v-row>
        <v-col cols="4" class="pa- ma-0">
          <v-btn color="primary" rounded dense small @click="printMtgCodesReport"
          class="mt-3">
            Mortgage Company List
          </v-btn>
        </v-col>
        <v-col cols="3" class="pa- ma-0">
          <v-btn color="primary" rounded dense small @click="printAddressLabelsReport"
          class="mt-3">
            Address Labels
          </v-btn>
        </v-col>
        <v-col cols="5" class="pa-0 ma-0">
          <v-text-field class="input-text-size" label="Wildcard Search
          (Mortgage Company Name, Contact Person, Address, Email Address)"
          v-model="criteriaState.mtgCodeWildcard"
          @input="searchByTimeOut" />
        </v-col>
      </v-row>
    </template>
    <template v-slot:[`editedItem`]="{}">
      <taxMortgageCodesDialog :baseCrudKey="baseCrudKey"/>
    </template>
    </CRUDList>
    </template>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { MortgageCodesHeader } from '../Utils/taxHeaders.utils';
import taxMortgageCodesDialog from './taxMortgageCodesDialog.vue';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients';
import '../../../assets/style.css';
import { SEARCH_DEBOUNCE_TIMER } from '../../tax/common-utils/constants';

const { backendRest } = clients.direct;
export default {
  name: 'taxMortgageCodesList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    taxMortgageCodesDialog,
  },
  data() {
    return {
      selectedRows: [],
      baseCrudKey: 'taxMortgageCodesList',
      selectedRow: null,
      dialogHeaderName: 'Mortgage Codes',
      headers: MortgageCodesHeader,
      gridLoading: defaultGridLoading(),
      delayTimerId: null,
    };
  },
  created() {
    manageGridLoading(this, true, 'Searching...');
  },
  destroyed() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.shared.taxMortgageCodesShared.selectedItems,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'mtgCode',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapActions(['reAuth']),
    ...mapMutations('shared/taxMortgageCodesShared', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/taxMortgageCodesShared', [
      'loadTaxMortgageCodesSharedRecords',
      'upserttaxMortgageCodes',
      'deleteMortgageCodes',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async handleMtgCodesLoad() {
      const { baseCrudKey, criteriaState } = this;
      const criteria = { ...criteriaState };
      this.loadTaxMortgageCodesSharedRecords({ criteria, baseCrudKey }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    async upsertRecords(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      await this.upserttaxMortgageCodes({ item: updatedItem, baseCrudKey });
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteMortgageCodes({ item, baseCrudKey });
      }
    },
    async printMtgCodesReport() {
      const { jwt } = await this.reAuth();
      let sortBy = 'mtgCode';
      let direction = 'asc';
      if ((this.criteriaState || {}).sortBy && this.criteriaState.sortBy.length) {
        sortBy = this.criteriaState.sortBy[0].column;
        direction = this.criteriaState.sortBy[0].direction;
      }
      const params = [
        `token=${jwt}`,
        `sortBy=${sortBy || ''}`,
        `direction=${direction || ''}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/shared/mortgage-codes-report${queryString}`;
      window.open(url, '_blank');
    },
    async printAddressLabelsReport() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/shared/mortgage-address-labels-report${queryString}`;
      window.open(url, '_blank');
    },
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        this.handleMtgCodesLoad();
      }, SEARCH_DEBOUNCE_TIMER);
    },
  },
};
</script>
